
export async function instantiate(imports={}, runInitializer=true) {
    const externrefBoxes = new WeakMap();
    // ref must be non-null
    function tryGetOrSetExternrefBox(ref, ifNotCached) {
        if (typeof ref !== 'object') return ifNotCached;
        const cachedBox = externrefBoxes.get(ref);
        if (cachedBox !== void 0) return cachedBox;
        externrefBoxes.set(ref, ifNotCached);
        return ifNotCached;
    }


    
    const js_code = {
        'kotlin.captureStackTrace' : () => new Error().stack,
        'kotlin.wasm.internal.throwJsError' : (message, wasmTypeName, stack) => { 
            const error = new Error();
            error.message = message;
            error.name = wasmTypeName;
            error.stack = stack;
            throw error;
             },
        'kotlin.wasm.internal.stringLength' : (x) => x.length,
        'kotlin.wasm.internal.jsExportStringToWasm' : (src, srcOffset, srcLength, dstAddr) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, dstAddr, srcLength);
            let arrayIndex = 0;
            let srcIndex = srcOffset;
            while (arrayIndex < srcLength) {
                mem16.set([src.charCodeAt(srcIndex)], arrayIndex);
                srcIndex++;
                arrayIndex++;
            }     
             },
        'kotlin.wasm.internal.doubleToExternref' : (x) => x,
        'kotlin.wasm.internal.intToExternref' : (x) => x,
        'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
        'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
        'kotlin.wasm.internal.importStringFromWasm' : (address, length, prefix) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, address, length);
            const str = String.fromCharCode.apply(null, mem16);
            return (prefix == null) ? str : prefix + str;
             },
        'kotlin.wasm.internal.getJsEmptyString' : () => '',
        'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
        'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
        'kotlin.wasm.internal.externrefHashCode' : 
        (() => {
        const dataView = new DataView(new ArrayBuffer(8));
        function numberHashCode(obj) {
            if ((obj | 0) === obj) {
                return obj | 0;
            } else {
                dataView.setFloat64(0, obj, true);
                return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
            }
        }
        
        const hashCodes = new WeakMap();
        function getObjectHashCode(obj) {
            const res = hashCodes.get(obj);
            if (res === undefined) {
                const POW_2_32 = 4294967296;
                const hash = (Math.random() * POW_2_32) | 0;
                hashCodes.set(obj, hash);
                return hash;
            }
            return res;
        }
        
        function getStringHashCode(str) {
            var hash = 0;
            for (var i = 0; i < str.length; i++) {
                var code  = str.charCodeAt(i);
                hash  = (hash * 31 + code) | 0;
            }
            return hash;
        }
        
        return (obj) => {
            if (obj == null) {
                return 0;
            }
            switch (typeof obj) {
                case "object":
                case "function":
                    return getObjectHashCode(obj);
                case "number":
                    return numberHashCode(obj);
                case "boolean":
                    return obj ? 1231 : 1237;
                default:
                    return getStringHashCode(String(obj)); 
            }
        }
        })(),
        'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
        'kotlin.wasm.internal.externrefToBoolean' : (ref) => Boolean(ref),
        'kotlin.wasm.internal.getJsTrue' : () => true,
        'kotlin.wasm.internal.getJsFalse' : () => false,
        'kotlin.wasm.internal.newJsArray' : () => [],
        'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
        'kotlin.wasm.internal.tryGetOrSetExternrefBox_$external_fun' : (p0, p1) => tryGetOrSetExternrefBox(p0, p1),
        'kotlin.io.printlnImpl' : (message) => console.log(message),
        'kotlin.io.printError' : (error) => console.error(error),
        'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
        'kotlin.js.jsArrayGet' : (array, index) => array[index],
        'kotlin.js.JsArray_$external_fun' : () => new Array(),
        'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
        'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => () => wasmExports['__callFunction_(()->Unit)'](f, ),
        'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
        'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
        'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
        'kotlin.time.dateNow' : () => Date.now(),
        'kotlinx.browser.window_$external_prop_getter' : () => window,
        'kotlinx.browser.document_$external_prop_getter' : () => document,
        'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
        'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
        'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => { return obj[index]; },
        'org.khronos.webgl.setMethodImplForUint32Array' : (obj, index, value) => { obj[index] = value; },
        'org.khronos.webgl.setMethodImplForInt32Array' : (obj, index, value) => { obj[index] = value; },
        'org.khronos.webgl.getMethodImplForInt32Array' : (obj, index) => { return obj[index]; },
        'org.khronos.webgl.setMethodImplForInt8Array' : (obj, index, value) => { obj[index] = value; },
        'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => { return obj[index]; },
        'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.set_$external_fun' : (_this, p0, p1, isDefault0) => _this.set(p0, isDefault0 ? undefined : p1, ),
        'org.khronos.webgl.ArrayBuffer_$external_fun' : (p0) => new ArrayBuffer(p0),
        'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
        'org.khronos.webgl.Uint32Array_$external_fun' : (p0) => new Uint32Array(p0),
        'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
        'org.khronos.webgl.Int32Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int32Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.subarray_$external_fun' : (_this, p0, p1) => _this.subarray(p0, p1),
        'org.khronos.webgl.buffer_$external_prop_getter_1' : (_this) => _this.buffer,
        'org.khronos.webgl.Int8Array_$external_fun' : (p0) => new Int8Array(p0),
        'org.khronos.webgl.Int8Array_$external_fun_1' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
        'org.khronos.webgl.buffer_$external_prop_getter_2' : (_this) => _this.buffer,
        'org.khronos.webgl.subarray_$external_fun_1' : (_this, p0, p1) => _this.subarray(p0, p1),
        'org.khronos.webgl.Float32Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Float32Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.subarray_$external_fun_2' : (_this, p0, p1) => _this.subarray(p0, p1),
        'org.khronos.webgl.getSupportedExtensions_$external_fun' : (_this, ) => _this.getSupportedExtensions(),
        'org.khronos.webgl.getExtension_$external_fun' : (_this, p0) => _this.getExtension(p0),
        'org.khronos.webgl.activeTexture_$external_fun' : (_this, p0) => _this.activeTexture(p0),
        'org.khronos.webgl.attachShader_$external_fun' : (_this, p0, p1) => _this.attachShader(p0, p1),
        'org.khronos.webgl.bindAttribLocation_$external_fun' : (_this, p0, p1, p2) => _this.bindAttribLocation(p0, p1, p2),
        'org.khronos.webgl.bindBuffer_$external_fun' : (_this, p0, p1) => _this.bindBuffer(p0, p1),
        'org.khronos.webgl.bindFramebuffer_$external_fun' : (_this, p0, p1) => _this.bindFramebuffer(p0, p1),
        'org.khronos.webgl.bindRenderbuffer_$external_fun' : (_this, p0, p1) => _this.bindRenderbuffer(p0, p1),
        'org.khronos.webgl.bindTexture_$external_fun' : (_this, p0, p1) => _this.bindTexture(p0, p1),
        'org.khronos.webgl.blendEquationSeparate_$external_fun' : (_this, p0, p1) => _this.blendEquationSeparate(p0, p1),
        'org.khronos.webgl.blendFuncSeparate_$external_fun' : (_this, p0, p1, p2, p3) => _this.blendFuncSeparate(p0, p1, p2, p3),
        'org.khronos.webgl.bufferData_$external_fun' : (_this, p0, p1, p2) => _this.bufferData(p0, p1, p2),
        'org.khronos.webgl.bufferSubData_$external_fun' : (_this, p0, p1, p2) => _this.bufferSubData(p0, p1, p2),
        'org.khronos.webgl.clear_$external_fun' : (_this, p0) => _this.clear(p0),
        'org.khronos.webgl.clearColor_$external_fun' : (_this, p0, p1, p2, p3) => _this.clearColor(p0, p1, p2, p3),
        'org.khronos.webgl.clearDepth_$external_fun' : (_this, p0) => _this.clearDepth(p0),
        'org.khronos.webgl.clearStencil_$external_fun' : (_this, p0) => _this.clearStencil(p0),
        'org.khronos.webgl.colorMask_$external_fun' : (_this, p0, p1, p2, p3) => _this.colorMask(p0, p1, p2, p3),
        'org.khronos.webgl.compileShader_$external_fun' : (_this, p0) => _this.compileShader(p0),
        'org.khronos.webgl.createBuffer_$external_fun' : (_this, ) => _this.createBuffer(),
        'org.khronos.webgl.createFramebuffer_$external_fun' : (_this, ) => _this.createFramebuffer(),
        'org.khronos.webgl.createProgram_$external_fun' : (_this, ) => _this.createProgram(),
        'org.khronos.webgl.createRenderbuffer_$external_fun' : (_this, ) => _this.createRenderbuffer(),
        'org.khronos.webgl.createShader_$external_fun' : (_this, p0) => _this.createShader(p0),
        'org.khronos.webgl.createTexture_$external_fun' : (_this, ) => _this.createTexture(),
        'org.khronos.webgl.cullFace_$external_fun' : (_this, p0) => _this.cullFace(p0),
        'org.khronos.webgl.deleteBuffer_$external_fun' : (_this, p0) => _this.deleteBuffer(p0),
        'org.khronos.webgl.deleteFramebuffer_$external_fun' : (_this, p0) => _this.deleteFramebuffer(p0),
        'org.khronos.webgl.deleteProgram_$external_fun' : (_this, p0) => _this.deleteProgram(p0),
        'org.khronos.webgl.deleteRenderbuffer_$external_fun' : (_this, p0) => _this.deleteRenderbuffer(p0),
        'org.khronos.webgl.deleteShader_$external_fun' : (_this, p0) => _this.deleteShader(p0),
        'org.khronos.webgl.deleteTexture_$external_fun' : (_this, p0) => _this.deleteTexture(p0),
        'org.khronos.webgl.depthFunc_$external_fun' : (_this, p0) => _this.depthFunc(p0),
        'org.khronos.webgl.depthMask_$external_fun' : (_this, p0) => _this.depthMask(p0),
        'org.khronos.webgl.depthRange_$external_fun' : (_this, p0, p1) => _this.depthRange(p0, p1),
        'org.khronos.webgl.disable_$external_fun' : (_this, p0) => _this.disable(p0),
        'org.khronos.webgl.disableVertexAttribArray_$external_fun' : (_this, p0) => _this.disableVertexAttribArray(p0),
        'org.khronos.webgl.drawArrays_$external_fun' : (_this, p0, p1, p2) => _this.drawArrays(p0, p1, p2),
        'org.khronos.webgl.drawElements_$external_fun' : (_this, p0, p1, p2, p3) => _this.drawElements(p0, p1, p2, p3),
        'org.khronos.webgl.enable_$external_fun' : (_this, p0) => _this.enable(p0),
        'org.khronos.webgl.enableVertexAttribArray_$external_fun' : (_this, p0) => _this.enableVertexAttribArray(p0),
        'org.khronos.webgl.flush_$external_fun' : (_this, ) => _this.flush(),
        'org.khronos.webgl.framebufferRenderbuffer_$external_fun' : (_this, p0, p1, p2, p3) => _this.framebufferRenderbuffer(p0, p1, p2, p3),
        'org.khronos.webgl.framebufferTexture2D_$external_fun' : (_this, p0, p1, p2, p3, p4) => _this.framebufferTexture2D(p0, p1, p2, p3, p4),
        'org.khronos.webgl.frontFace_$external_fun' : (_this, p0) => _this.frontFace(p0),
        'org.khronos.webgl.generateMipmap_$external_fun' : (_this, p0) => _this.generateMipmap(p0),
        'org.khronos.webgl.getParameter_$external_fun' : (_this, p0) => _this.getParameter(p0),
        'org.khronos.webgl.getError_$external_fun' : (_this, ) => _this.getError(),
        'org.khronos.webgl.getProgramParameter_$external_fun' : (_this, p0, p1) => _this.getProgramParameter(p0, p1),
        'org.khronos.webgl.getProgramInfoLog_$external_fun' : (_this, p0) => _this.getProgramInfoLog(p0),
        'org.khronos.webgl.getShaderParameter_$external_fun' : (_this, p0, p1) => _this.getShaderParameter(p0, p1),
        'org.khronos.webgl.getShaderInfoLog_$external_fun' : (_this, p0) => _this.getShaderInfoLog(p0),
        'org.khronos.webgl.getUniformLocation_$external_fun' : (_this, p0, p1) => _this.getUniformLocation(p0, p1),
        'org.khronos.webgl.linkProgram_$external_fun' : (_this, p0) => _this.linkProgram(p0),
        'org.khronos.webgl.pixelStorei_$external_fun' : (_this, p0, p1) => _this.pixelStorei(p0, p1),
        'org.khronos.webgl.readPixels_$external_fun' : (_this, p0, p1, p2, p3, p4, p5, p6) => _this.readPixels(p0, p1, p2, p3, p4, p5, p6),
        'org.khronos.webgl.renderbufferStorage_$external_fun' : (_this, p0, p1, p2, p3) => _this.renderbufferStorage(p0, p1, p2, p3),
        'org.khronos.webgl.scissor_$external_fun' : (_this, p0, p1, p2, p3) => _this.scissor(p0, p1, p2, p3),
        'org.khronos.webgl.shaderSource_$external_fun' : (_this, p0, p1) => _this.shaderSource(p0, p1),
        'org.khronos.webgl.stencilFunc_$external_fun' : (_this, p0, p1, p2) => _this.stencilFunc(p0, p1, p2),
        'org.khronos.webgl.stencilFuncSeparate_$external_fun' : (_this, p0, p1, p2, p3) => _this.stencilFuncSeparate(p0, p1, p2, p3),
        'org.khronos.webgl.stencilMask_$external_fun' : (_this, p0) => _this.stencilMask(p0),
        'org.khronos.webgl.stencilMaskSeparate_$external_fun' : (_this, p0, p1) => _this.stencilMaskSeparate(p0, p1),
        'org.khronos.webgl.stencilOp_$external_fun' : (_this, p0, p1, p2) => _this.stencilOp(p0, p1, p2),
        'org.khronos.webgl.stencilOpSeparate_$external_fun' : (_this, p0, p1, p2, p3) => _this.stencilOpSeparate(p0, p1, p2, p3),
        'org.khronos.webgl.texImage2D_$external_fun' : (_this, p0, p1, p2, p3, p4, p5, p6, p7, p8) => _this.texImage2D(p0, p1, p2, p3, p4, p5, p6, p7, p8),
        'org.khronos.webgl.texImage2D_$external_fun_1' : (_this, p0, p1, p2, p3, p4, p5) => _this.texImage2D(p0, p1, p2, p3, p4, p5),
        'org.khronos.webgl.texParameteri_$external_fun' : (_this, p0, p1, p2) => _this.texParameteri(p0, p1, p2),
        'org.khronos.webgl.uniform1fv_$external_fun' : (_this, p0, p1) => _this.uniform1fv(p0, p1),
        'org.khronos.webgl.uniform1i_$external_fun' : (_this, p0, p1) => _this.uniform1i(p0, p1),
        'org.khronos.webgl.uniform1iv_$external_fun' : (_this, p0, p1) => _this.uniform1iv(p0, p1),
        'org.khronos.webgl.uniform2fv_$external_fun' : (_this, p0, p1) => _this.uniform2fv(p0, p1),
        'org.khronos.webgl.uniform2iv_$external_fun' : (_this, p0, p1) => _this.uniform2iv(p0, p1),
        'org.khronos.webgl.uniform3fv_$external_fun' : (_this, p0, p1) => _this.uniform3fv(p0, p1),
        'org.khronos.webgl.uniform3iv_$external_fun' : (_this, p0, p1) => _this.uniform3iv(p0, p1),
        'org.khronos.webgl.uniform4fv_$external_fun' : (_this, p0, p1) => _this.uniform4fv(p0, p1),
        'org.khronos.webgl.uniform4iv_$external_fun' : (_this, p0, p1) => _this.uniform4iv(p0, p1),
        'org.khronos.webgl.uniformMatrix2fv_$external_fun' : (_this, p0, p1, p2) => _this.uniformMatrix2fv(p0, p1, p2),
        'org.khronos.webgl.uniformMatrix3fv_$external_fun' : (_this, p0, p1, p2) => _this.uniformMatrix3fv(p0, p1, p2),
        'org.khronos.webgl.uniformMatrix4fv_$external_fun' : (_this, p0, p1, p2) => _this.uniformMatrix4fv(p0, p1, p2),
        'org.khronos.webgl.useProgram_$external_fun' : (_this, p0) => _this.useProgram(p0),
        'org.khronos.webgl.vertexAttribPointer_$external_fun' : (_this, p0, p1, p2, p3, p4, p5) => _this.vertexAttribPointer(p0, p1, p2, p3, p4, p5),
        'org.khronos.webgl.viewport_$external_fun' : (_this, p0, p1, p2, p3) => _this.viewport(p0, p1, p2, p3),
        'org.khronos.webgl.DataView_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new DataView(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.buffer_$external_prop_getter_3' : (_this) => _this.buffer,
        'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
        'org.khronos.webgl.byteLength_$external_prop_getter_1' : (_this) => _this.byteLength,
        'org.khronos.webgl.getInt8_$external_fun' : (_this, p0) => _this.getInt8(p0),
        'org.khronos.webgl.getInt16_$external_fun' : (_this, p0, p1, isDefault0) => _this.getInt16(p0, isDefault0 ? undefined : p1, ),
        'org.khronos.webgl.getInt32_$external_fun' : (_this, p0, p1, isDefault0) => _this.getInt32(p0, isDefault0 ? undefined : p1, ),
        'org.khronos.webgl.getFloat32_$external_fun' : (_this, p0, p1, isDefault0) => _this.getFloat32(p0, isDefault0 ? undefined : p1, ),
        'org.khronos.webgl.setInt8_$external_fun' : (_this, p0, p1) => _this.setInt8(p0, p1),
        'org.khronos.webgl.setInt16_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setInt16(p0, p1, isDefault0 ? undefined : p2, ),
        'org.khronos.webgl.setInt32_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setInt32(p0, p1, isDefault0 ? undefined : p2, ),
        'org.khronos.webgl.setFloat32_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setFloat32(p0, p1, isDefault0 ? undefined : p2, ),
        'org.w3c.dom.css.color_$external_prop_setter' : (_this, v) => _this.color = v,
        'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
        'org.w3c.dom.css.font_$external_prop_setter' : (_this, v) => _this.font = v,
        'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
        'org.w3c.dom.css.margin_$external_prop_setter' : (_this, v) => _this.margin = v,
        'org.w3c.dom.css.overflowX_$external_prop_setter' : (_this, v) => _this.overflowX = v,
        'org.w3c.dom.css.overflowY_$external_prop_setter' : (_this, v) => _this.overflowY = v,
        'org.w3c.dom.css.padding_$external_prop_setter' : (_this, v) => _this.padding = v,
        'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
        'org.w3c.dom.css.right_$external_prop_setter' : (_this, v) => _this.right = v,
        'org.w3c.dom.css.visibility_$external_prop_setter' : (_this, v) => _this.visibility = v,
        'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
        'org.w3c.dom.encryptedmedia.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0),
        'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
        'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
        'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
        'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
        'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1, p2) => _this.removeEventListener(p0, p1, p2),
        'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
        'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
        'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
        'org.w3c.dom.events.charCode_$external_prop_getter' : (_this) => _this.charCode,
        'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
        'org.w3c.dom.events.clientX_$external_prop_getter' : (_this) => _this.clientX,
        'org.w3c.dom.events.clientY_$external_prop_getter' : (_this) => _this.clientY,
        'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
        'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
        'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
        'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
        'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
        'org.w3c.dom.events.deltaZ_$external_prop_getter' : (_this) => _this.deltaZ,
        'org.w3c.dom.events.deltaMode_$external_prop_getter' : (_this) => _this.deltaMode,
        'org.w3c.dom.events.DOM_DELTA_PIXEL_$external_prop_getter' : (_this) => _this.DOM_DELTA_PIXEL,
        'org.w3c.dom.events.DOM_DELTA_LINE_$external_prop_getter' : (_this) => _this.DOM_DELTA_LINE,
        'org.w3c.dom.events.DOM_DELTA_PAGE_$external_prop_getter' : (_this) => _this.DOM_DELTA_PAGE,
        'org.w3c.dom.events.Companion_$external_object_getInstance' : () => WheelEvent,
        'org.w3c.dom.getMethodImplForHTMLCollection' : (obj, index) => { return obj[index]; },
        'org.w3c.dom.getMethodImplForDataTransferItemList' : (obj, index) => { return obj[index]; },
        'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.w3c.dom.innerWidth_$external_prop_getter' : (_this) => _this.innerWidth,
        'org.w3c.dom.innerHeight_$external_prop_getter' : (_this) => _this.innerHeight,
        'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
        'org.w3c.dom.close_$external_fun' : (_this, ) => _this.close(),
        'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0),
        'org.w3c.dom.href_$external_prop_getter' : (_this) => _this.href,
        'org.w3c.dom.search_$external_prop_getter' : (_this) => _this.search,
        'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
        'org.w3c.dom.title_$external_prop_setter' : (_this, v) => _this.title = v,
        'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
        'org.w3c.dom.__convertKotlinClosureToJsClosure_((Js?,String,Int,Int,Js?)->Js?)' : (f) => (p0, p1, p2, p3, p4) => wasmExports['__callFunction_((Js?,String,Int,Int,Js?)->Js?)'](f, p0, p1, p2, p3, p4),
        'org.w3c.dom.fullscreenElement_$external_prop_getter' : (_this) => _this.fullscreenElement,
        'org.w3c.dom.getElementsByTagName_$external_fun' : (_this, p0) => _this.getElementsByTagName(p0),
        'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.createEvent_$external_fun' : (_this, p0) => _this.createEvent(p0),
        'org.w3c.dom.exitFullscreen_$external_fun' : (_this, ) => _this.exitFullscreen(),
        'org.w3c.dom.querySelector_$external_fun' : (_this, p0) => _this.querySelector(p0),
        'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
        'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
        'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
        'org.w3c.dom.requestFullscreen_$external_fun' : (_this, ) => _this.requestFullscreen(),
        'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
        'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
        'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
        'org.w3c.dom.src_$external_prop_setter' : (_this, v) => _this.src = v,
        'org.w3c.dom.HTMLImageElement_$external_class_instanceof' : (x) => x instanceof HTMLImageElement,
        'org.w3c.dom.HTMLVideoElement_$external_class_instanceof' : (x) => x instanceof HTMLVideoElement,
        'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
        'org.w3c.dom.addColorStop_$external_fun' : (_this, p0, p1) => _this.addColorStop(p0, p1),
        'org.w3c.dom.transform_$external_fun' : (_this, p0, p1, p2, p3, p4, p5) => _this.transform(p0, p1, p2, p3, p4, p5),
        'org.w3c.dom.setTransform_$external_fun' : (_this, p0, p1, p2, p3, p4, p5) => _this.setTransform(p0, p1, p2, p3, p4, p5),
        'org.w3c.dom.clearTimeout_$external_fun' : (_this, p0, isDefault0) => _this.clearTimeout(isDefault0 ? undefined : p0, ),
        'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
        'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
        'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
        'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.w3c.dom.touches_$external_prop_getter' : (_this) => _this.touches,
        'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
        'org.w3c.dom.identifier_$external_prop_getter' : (_this) => _this.identifier,
        'org.w3c.dom.clientX_$external_prop_getter' : (_this) => _this.clientX,
        'org.w3c.dom.clientY_$external_prop_getter' : (_this) => _this.clientY,
        'org.w3c.dom.href_$external_prop_setter' : (_this, v) => _this.href = v,
        'org.w3c.dom.rel_$external_prop_setter' : (_this, v) => _this.rel = v,
        'org.w3c.dom.type_$external_prop_setter' : (_this, v) => _this.type = v,
        'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
        'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
        'org.w3c.dom.length_$external_prop_getter_1' : (_this) => _this.length,
        'org.w3c.dom.items_$external_prop_getter' : (_this) => _this.items,
        'org.w3c.dom.getAsFile_$external_fun' : (_this, ) => _this.getAsFile(),
        'org.w3c.dom.ondragend_$external_prop_setter' : (_this, v) => _this.ondragend = v,
        'org.w3c.dom.ondragenter_$external_prop_setter' : (_this, v) => _this.ondragenter = v,
        'org.w3c.dom.ondragexit_$external_prop_setter' : (_this, v) => _this.ondragexit = v,
        'org.w3c.dom.ondragleave_$external_prop_setter' : (_this, v) => _this.ondragleave = v,
        'org.w3c.dom.ondragover_$external_prop_setter' : (_this, v) => _this.ondragover = v,
        'org.w3c.dom.ondragstart_$external_prop_setter' : (_this, v) => _this.ondragstart = v,
        'org.w3c.dom.ondrop_$external_prop_setter' : (_this, v) => _this.ondrop = v,
        'org.w3c.dom.onerror_$external_prop_setter' : (_this, v) => _this.onerror = v,
        'org.w3c.dom.onload_$external_prop_setter' : (_this, v) => _this.onload = v,
        'org.w3c.dom.prepend_$external_fun' : (_this, p0) => _this.prepend(...p0),
        'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
        'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
        'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
        'org.w3c.dom.save_$external_fun' : (_this, ) => _this.save(),
        'org.w3c.dom.restore_$external_fun' : (_this, ) => _this.restore(),
        'org.w3c.dom.globalAlpha_$external_prop_setter' : (_this, v) => _this.globalAlpha = v,
        'org.w3c.dom.globalCompositeOperation_$external_prop_setter' : (_this, v) => _this.globalCompositeOperation = v,
        'org.w3c.dom.strokeStyle_$external_prop_setter' : (_this, v) => _this.strokeStyle = v,
        'org.w3c.dom.fillStyle_$external_prop_setter' : (_this, v) => _this.fillStyle = v,
        'org.w3c.dom.createLinearGradient_$external_fun' : (_this, p0, p1, p2, p3) => _this.createLinearGradient(p0, p1, p2, p3),
        'org.w3c.dom.createRadialGradient_$external_fun' : (_this, p0, p1, p2, p3, p4, p5) => _this.createRadialGradient(p0, p1, p2, p3, p4, p5),
        'org.w3c.dom.createPattern_$external_fun' : (_this, p0, p1) => _this.createPattern(p0, p1),
        'org.w3c.dom.clearRect_$external_fun' : (_this, p0, p1, p2, p3) => _this.clearRect(p0, p1, p2, p3),
        'org.w3c.dom.beginPath_$external_fun' : (_this, ) => _this.beginPath(),
        'org.w3c.dom.fill_$external_fun' : (_this, p0, isDefault0) => _this.fill(isDefault0 ? undefined : p0, ),
        'org.w3c.dom.stroke_$external_fun' : (_this, ) => _this.stroke(),
        'org.w3c.dom.clip_$external_fun' : (_this, p0, isDefault0) => _this.clip(isDefault0 ? undefined : p0, ),
        'org.w3c.dom.drawImage_$external_fun' : (_this, p0, p1, p2) => _this.drawImage(p0, p1, p2),
        'org.w3c.dom.drawImage_$external_fun_1' : (_this, p0, p1, p2, p3, p4) => _this.drawImage(p0, p1, p2, p3, p4),
        'org.w3c.dom.createImageData_$external_fun' : (_this, p0, p1) => _this.createImageData(p0, p1),
        'org.w3c.dom.getImageData_$external_fun' : (_this, p0, p1, p2, p3) => _this.getImageData(p0, p1, p2, p3),
        'org.w3c.dom.putImageData_$external_fun' : (_this, p0, p1, p2) => _this.putImageData(p0, p1, p2),
        'org.w3c.dom.lineWidth_$external_prop_setter' : (_this, v) => _this.lineWidth = v,
        'org.w3c.dom.lineCap_$external_prop_setter' : (_this, v) => _this.lineCap = v,
        'org.w3c.dom.lineJoin_$external_prop_setter' : (_this, v) => _this.lineJoin = v,
        'org.w3c.dom.lineDashOffset_$external_prop_setter' : (_this, v) => _this.lineDashOffset = v,
        'org.w3c.dom.setLineDash_$external_fun' : (_this, p0) => _this.setLineDash(p0),
        'org.w3c.dom.font_$external_prop_setter' : (_this, v) => _this.font = v,
        'org.w3c.dom.closePath_$external_fun' : (_this, ) => _this.closePath(),
        'org.w3c.dom.moveTo_$external_fun' : (_this, p0, p1) => _this.moveTo(p0, p1),
        'org.w3c.dom.lineTo_$external_fun' : (_this, p0, p1) => _this.lineTo(p0, p1),
        'org.w3c.dom.quadraticCurveTo_$external_fun' : (_this, p0, p1, p2, p3) => _this.quadraticCurveTo(p0, p1, p2, p3),
        'org.w3c.dom.bezierCurveTo_$external_fun' : (_this, p0, p1, p2, p3, p4, p5) => _this.bezierCurveTo(p0, p1, p2, p3, p4, p5),
        'org.w3c.dom.languages_$external_prop_getter' : (_this) => _this.languages,
        'org.w3c.dom.url.createObjectURL_$external_fun' : (_this, p0) => _this.createObjectURL(p0),
        'org.w3c.dom.url.revokeObjectURL_$external_fun' : (_this, p0) => _this.revokeObjectURL(p0),
        'org.w3c.dom.url.Companion_$external_object_getInstance' : () => URL,
        'org.w3c.files.BlobPropertyBag_js_code' : (type) => { return { type }; },
        'org.w3c.files.Blob_$external_fun' : (p0, p1, isDefault0, isDefault1) => new Blob(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
        'org.w3c.files.size_$external_prop_getter' : (_this) => _this.size,
        'org.w3c.files.name_$external_prop_getter' : (_this) => _this.name,
        'org.w3c.files.FileReader_$external_fun' : () => new FileReader(),
        'org.w3c.files.result_$external_prop_getter' : (_this) => _this.result,
        'org.w3c.files.error_$external_prop_getter' : (_this) => _this.error,
        'org.w3c.files.onload_$external_prop_setter' : (_this, v) => _this.onload = v,
        'org.w3c.files.onerror_$external_prop_setter' : (_this, v) => _this.onerror = v,
        'org.w3c.files.readAsArrayBuffer_$external_fun' : (_this, p0) => _this.readAsArrayBuffer(p0),
        'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
        'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.w3c.xhr.XMLHttpRequest_$external_fun' : () => new XMLHttpRequest(),
        'org.w3c.xhr.status_$external_prop_getter' : (_this) => _this.status,
        'org.w3c.xhr.statusText_$external_prop_getter' : (_this) => _this.statusText,
        'org.w3c.xhr.responseType_$external_prop_setter' : (_this, v) => _this.responseType = v,
        'org.w3c.xhr.response_$external_prop_getter' : (_this) => _this.response,
        'org.w3c.xhr.open_$external_fun' : (_this, p0, p1, p2, p3, p4, isDefault0, isDefault1) => _this.open(p0, p1, p2, isDefault0 ? undefined : p3, isDefault1 ? undefined : p4, ),
        'org.w3c.xhr.setRequestHeader_$external_fun' : (_this, p0, p1) => _this.setRequestHeader(p0, p1),
        'org.w3c.xhr.send_$external_fun' : (_this, p0) => _this.send(p0),
        'org.w3c.xhr.send_$external_fun_1' : (_this, ) => _this.send(),
        'org.w3c.xhr.abort_$external_fun' : (_this, ) => _this.abort(),
        'org.w3c.xhr.getAllResponseHeaders_$external_fun' : (_this, ) => _this.getAllResponseHeaders(),
        'org.w3c.xhr.onerror_$external_prop_setter' : (_this, v) => _this.onerror = v,
        'org.w3c.xhr.onload_$external_prop_setter' : (_this, v) => _this.onload = v,
        'korlibs.time.internal.process_hrtime' : () => { return process.hrtime(); },
        'korlibs.time.internal.Date_now' : () => { return Date.now(); },
        'korlibs.time.internal.isNodeJs' : () => { return (typeof process === 'object' && typeof require === 'function'); },
        'korlibs.time.internal.process_hrtime_1' : (relative) => { return process.hrtime(relative); },
        'korlibs.time.internal.HRTime_get' : (time, index) => { return time[index] },
        'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
        'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
        'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
        'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
        'kotlinx.coroutines.console_$external_prop_getter' : () => console,
        'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
        'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
        'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
        'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
            const handler = (event) => {
                if (event.source == window && event.data == 'dispatchCoroutine') {
                    event.stopPropagation();
                    process();
                }
            }
            window.addEventListener('message', handler, true);
        },
        'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
        'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
        'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
        'korlibs.logger.error_$external_fun' : (_this, p0) => _this.error(...p0),
        'korlibs.logger.warn_$external_fun' : (_this, p0) => _this.warn(...p0),
        'korlibs.logger.info_$external_fun' : (_this, p0) => _this.info(...p0),
        'korlibs.logger.log_$external_fun' : (_this, p0) => _this.log(...p0),
        'korlibs.logger.console_$external_prop_getter' : () => console,
        'korlibs.platform.isDenoJs' : () => { return (typeof Deno === 'object' && Deno.statSync) },
        'korlibs.platform.isWeb' : () => { return (typeof window === 'object') },
        'korlibs.platform.isNodeJs' : () => { return ((typeof process !== 'undefined') && process.release && (process.release.name.search(/node|io.js/) !== -1)) },
        'korlibs.platform.isWorker' : () => { return (typeof importScripts === 'function') },
        'korlibs.platform.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
        'korlibs.platform.navigator_$external_prop_getter' : () => navigator,
        'korlibs.platform.platform_$external_prop_getter' : (_this) => _this.platform,
        'korlibs.platform.process_$external_prop_getter' : () => process,
        'korlibs.audio.sound.createBufferSource_$external_fun' : (_this, ) => _this.createBufferSource(),
        'korlibs.audio.sound.createBuffer_$external_fun' : (_this, p0, p1, p2) => _this.createBuffer(p0, p1, p2),
        'korlibs.audio.sound.destination_$external_prop_getter' : (_this) => _this.destination,
        'korlibs.audio.sound.resume_$external_fun' : (_this, ) => _this.resume(),
        'korlibs.audio.sound.AudioContext_$external_fun' : () => new AudioContext(),
        'korlibs.audio.sound.globalAudioContext_$external_prop_getter' : (_this) => _this.globalAudioContext,
        'korlibs.audio.sound.globalAudioContext_$external_prop_setter' : (_this, v) => _this.globalAudioContext = v,
        'korlibs.audio.sound.onended_$external_prop_setter' : (_this, v) => _this.onended = v,
        'korlibs.audio.sound.start_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.start(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
        'korlibs.audio.sound.buffer_$external_prop_setter' : (_this, v) => _this.buffer = v,
        'korlibs.audio.sound.connect_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1) => _this.connect(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'korlibs.audio.sound.disconnect_$external_fun' : (_this, p0, isDefault0) => _this.disconnect(isDefault0 ? undefined : p0, ),
        'korlibs.image.format.width_$external_prop_getter' : (_this) => _this.width,
        'korlibs.image.format.height_$external_prop_getter' : (_this) => _this.height,
        'korlibs.image.format.getContext_$external_fun' : (_this, p0, p1) => _this.getContext(p0, ...p1),
        'korlibs.image.format.toDataURL_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.toDataURL(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
        'korlibs.image.format.width_$external_prop_getter_1' : (_this) => _this.width,
        'korlibs.image.format.height_$external_prop_getter_1' : (_this) => _this.height,
        'korlibs.image.format.Uint8ClampedArray_set' : (array, index, value) => { array[index] = value },
        'korlibs.image.format.NONZERO' : () => { return 'nonzero'; },
        'korlibs.image.format.EVENODD' : () => { return 'evenodd'; },
        'korlibs.image.format.createConicGradient_$external_prop_getter' : (_this) => _this.createConicGradient,
        'korlibs.image.format.__callJsClosure_((Double,Double,Double)->Js)' : (f, p0, p1, p2) => f(p0, p1, p2),
        'korlibs.io.getJsGlobalDynamic' : () => { return ((typeof globalThis !== 'undefined') ? globalThis : ((typeof global !== 'undefined') ? global : self)); },
        'korlibs.io.dynamic.JsAny_get' : (obj, key) => { return obj[key]; },
        'korlibs.io.dynamic.JsAny_set' : (obj, key, value) => { obj[key] = value; },
        'korlibs.io.file.slice_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.slice(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
        'korlibs.io.lang.TextEncoder_$external_fun' : (p0) => new TextEncoder(p0),
        'korlibs.io.lang.TextDecoder_$external_fun' : (p0) => new TextDecoder(p0),
        'korlibs.io.lang.encoding_$external_prop_getter' : (_this) => _this.encoding,
        'korlibs.io.lang.decode_$external_fun' : (_this, p0) => _this.decode(p0),
        'korlibs.io.runtime.browser.TYPE_ARRAYBUFFER' : () => { return 'arraybuffer'; },
        'korlibs.io.runtime.browser.platform_$external_prop_getter' : (_this) => _this.platform,
        'korlibs.io.runtime.browser.navigator_$external_prop_getter' : () => navigator,
        'korlibs.io.util.runCatchingJsExceptions' : (block) => { try { return { result: block(), error: null }; } catch (e) { return { result: null, error: e }; } },
        'korlibs.io.util.__convertKotlinClosureToJsClosure_(()->Js)' : (f) => () => wasmExports['__callFunction_(()->Js)'](f, ),
        'korlibs.io.util.result_$external_prop_getter' : (_this) => _this.result,
        'korlibs.io.util.error_$external_prop_getter' : (_this) => _this.error,
        'korlibs.io.util.message_$external_prop_getter' : (_this) => _this.message,
        'korlibs.io.wasm.jsEmptyObj' : () => { return {}; },
        'korlibs.io.wasm.JsAny_get' : (obj, key) => { return obj[key]; },
        'korlibs.io.wasm.JsAny_set' : (obj, key, value) => { obj[key] = value; },
        'korlibs.io.wasm.JsAny_has' : (obj, key) => { return obj[key] !== undefined; },
        'korlibs.graphics.gl._isTouchDevice' : () => { return ('ontouchstart' in window || navigator.maxTouchPoints); },
        'korlibs.kgl.drawArraysInstanced_$external_fun' : (_this, p0, p1, p2, p3) => _this.drawArraysInstanced(p0, p1, p2, p3),
        'korlibs.kgl.drawElementsInstanced_$external_fun' : (_this, p0, p1, p2, p3, p4) => _this.drawElementsInstanced(p0, p1, p2, p3, p4),
        'korlibs.kgl.vertexAttribDivisor_$external_fun' : (_this, p0, p1) => _this.vertexAttribDivisor(p0, p1),
        'korlibs.kgl.bindBufferRange_$external_fun' : (_this, p0, p1, p2, p3, p4) => _this.bindBufferRange(p0, p1, p2, p3, p4),
        'korlibs.kgl.getUniformBlockIndex_$external_fun' : (_this, p0, p1) => _this.getUniformBlockIndex(p0, p1),
        'korlibs.kgl.uniformBlockBinding_$external_fun' : (_this, p0, p1, p2) => _this.uniformBlockBinding(p0, p1, p2),
        'korlibs.kgl.createVertexArray_$external_fun' : (_this, ) => _this.createVertexArray(),
        'korlibs.kgl.bindVertexArray_$external_fun' : (_this, p0) => _this.bindVertexArray(p0),
        'korlibs.kgl.getContext_$external_fun' : (_this, p0, p1) => _this.getContext(p0, ...p1),
        'korlibs.kgl.stringify_$external_fun' : (_this, p0) => _this.stringify(p0),
        'korlibs.kgl.JSON_$external_object_getInstance' : () => JSON,
        'korlibs.korge.service.storage.keys_$external_fun' : (_this, p0) => _this.keys(p0),
        'korlibs.korge.service.storage.JsObject_$external_object_getInstance' : () => Object,
        'korlibs.render.axes_$external_prop_getter' : (_this) => _this.axes,
        'korlibs.render.buttons_$external_prop_getter' : (_this) => _this.buttons,
        'korlibs.render.id_$external_prop_getter' : (_this) => _this.id,
        'korlibs.render.mapping_$external_prop_getter' : (_this) => _this.mapping,
        'korlibs.render.getGamepads_$external_prop_getter' : (_this) => _this.getGamepads,
        'korlibs.render.__callJsClosure_(()->Js)' : (f, ) => f(),
        'korlibs.render.navigator_$external_prop_getter' : () => navigator,
        'korlibs.render.value_$external_prop_getter' : (_this) => _this.value,
        'korlibs.render.canvas_$external_prop_setter' : (_this, v) => _this.canvas = v,
        'korlibs.render.korgwShowUnsupportedKeys_$external_prop_getter' : (_this) => _this.korgwShowUnsupportedKeys,
        'korlibs.render.force_$external_prop_getter' : (_this) => _this.force
    }
    
    // Placed here to give access to it from externals (js_code)
    let wasmInstance;
    let require; 
    let wasmExports;

    const isNodeJs = (typeof process !== 'undefined') && (process.release.name === 'node');
    const isStandaloneJsVM =
        !isNodeJs && (
            typeof d8 !== 'undefined' // V8
            || typeof inIon !== 'undefined' // SpiderMonkey
            || typeof jscOptions !== 'undefined' // JavaScriptCore
        );
    const isBrowser = !isNodeJs && !isStandaloneJsVM && (typeof window !== 'undefined');
    
    if (!isNodeJs && !isStandaloneJsVM && !isBrowser) {
      throw "Supported JS engine not detected";
    }
    
    const wasmFilePath = './7drl-2024-wasm-js.wasm';
    const importObject = {
        js_code,

    };
    
    try {
      if (isNodeJs) {
        const module = await import(/* webpackIgnore: true */'node:module');
        require = module.default.createRequire(import.meta.url);
        const fs = require('fs');
        const path = require('path');
        const url = require('url');
        const filepath = url.fileURLToPath(import.meta.url);
        const dirpath = path.dirname(filepath);
        const wasmBuffer = fs.readFileSync(path.resolve(dirpath, wasmFilePath));
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject);
      }
      
      if (isStandaloneJsVM) {
        const wasmBuffer = read(wasmFilePath, 'binary');
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject);
      }
      
      if (isBrowser) {
        wasmInstance = (await WebAssembly.instantiateStreaming(fetch(wasmFilePath), importObject)).instance;
      }
    } catch (e) {
      if (e instanceof WebAssembly.CompileError) {
        let text = `Please make sure that your runtime environment supports the latest version of Wasm GC and Exception-Handling proposals.
For more information, see https://kotl.in/wasm-help
`;
        if (isBrowser) {
          console.error(text);
        } else {
          const t = "\n" + text;
          if (typeof console !== "undefined" && console.log !== void 0) 
            console.log(t);
          else 
            print(t);
        }
      }
      throw e;
    }
    
    wasmExports = wasmInstance.exports;
    if (runInitializer) {
        wasmExports._initialize();
    }

    return { instance: wasmInstance,  exports: wasmExports };
}
